import { Component, ViewChild } from '@angular/core';
import { OAuthService } from 'angular-oauth2-oidc';
import { Timestamp } from '../../../timestamp/Timestamp';
import { AboutDialogComponent } from '../../features/about-dialog/about-dialog.component';
import { SupportEmailService } from '../../core/services/support-email.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent {
  @ViewChild('aboutDialog') aboutDialog!: AboutDialogComponent;
  compiledTimestamp: string = Timestamp.stamp;

  constructor(
    private oauthService: OAuthService,
    private supportEmailService: SupportEmailService
  ) {}

  getEmailTemplate(): string {
    // Use shared service without browser info
    return this.supportEmailService.getEmailTemplate(false);
  }
} 